import React, { useEffect } from 'react';
import { typeButtonsData } from './typebuttons-data';
import './ApartmentTypeButtons.scss';

const ApartmentTypeButtons = ({
  onSelect,
  currentPano,
  activeIndex,
  setActiveIndex,
}) => {
  useEffect(() => {
    if (currentPano?._id) {
      const foundIndex = typeButtonsData.findIndex((item) =>
        item.objects.some((obj) => obj.id === currentPano._id)
      );
      if (foundIndex !== -1) {
        setActiveIndex(foundIndex);
      }
    }
  }, [currentPano, setActiveIndex]);

  const handleSelect = (item, index) => {
    setActiveIndex(index);
    onSelect(item);
  };

  return (
    <div className="apartment-type-buttons">
      {typeButtonsData.map((item, index) => (
        <button
          key={index}
          className={`apartment-button ${
            activeIndex === index ? 'active' : ''
          }`}
          onClick={() => handleSelect(item, index)}
        >
          {item.image.name}
        </button>
      ))}
    </div>
  );
};

export default ApartmentTypeButtons;
